import { Clock, BarChart2, GraduationCap, CalendarCheck } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import AppLauncherItem from './AppLauncherItem';
import type { LucideIcon } from 'lucide-react';
import { useContext } from 'react';
import { CurrentUserContext } from '@/context/CurrentUserContext';

const staticAppItems: { key: string; Icon: LucideIcon; title: string; url: string; backgroundColor: string }[] = [
  { key: 'timeEntry', Icon: Clock, title: 'Time Entry', url: 'https://pbsapps.teampbs.com/timeentry/client/', backgroundColor: '#2E7BC4' },
  { key: 'dataCollection', Icon: BarChart2, title: 'Data Collection', url: 'https://datacollection.teampbs.com/', backgroundColor: '#2A9D8F' },
  { key: 'lms', Icon: GraduationCap, title: 'LMS', url: 'https://lms.teampbs.com/', backgroundColor: '#6A5ACD' },
];

const AppLauncherCard = () => {
  const { currentUser } = useContext(CurrentUserContext);
  const username = currentUser?.LoginName?.replace(/^POSITIVE\\/, '') ?? '';
  const availabilityUrl = `https://availability.teampbs.com/Availability/${username ? `?login=${username}` : ''}`;

  return (
    <Card className="m-2 md:m-8 app-launcher">
      <CardHeader className="pb-0">
        <CardTitle className="text-[14pt]">PBS Apps</CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <div className="flex flex-wrap gap-2">
          {staticAppItems.map(item => (
            <AppLauncherItem
              key={item.key}
              Icon={item.Icon}
              title={item.title}
              url={item.url}
              backgroundColor={item.backgroundColor}
            />
          ))}
          <AppLauncherItem
            key="availability"
            Icon={CalendarCheck}
            title="Availability"
            url={availabilityUrl}
            backgroundColor="#0891B2"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default AppLauncherCard;
